(() => {
  console.log('cart-delivery-request.js is running');

  function formatDate(date) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  function addDays(date, days) {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + days);
    return newDate;
  }

  const dateInputs = document.querySelectorAll('[data-delivery-date]');
  console.log('dateInputs:', dateInputs.length);

  if (!dateInputs.length) return;

  const today = new Date();
  const minDate = formatDate(addDays(today, 3));
  const maxDate = formatDate(addDays(today, 10));

  dateInputs.forEach((dateInput) => {
    dateInput.setAttribute('min', minDate);
    dateInput.setAttribute('max', maxDate);
    console.log('set min/max:', minDate, maxDate);

    const block = dateInput.closest('[data-delivery-request]');
    const errorBox = block ? block.querySelector('[data-delivery-error]') : null;
    const form = dateInput.closest('form');

    const clearError = () => {
      if (!errorBox) return;
      errorBox.textContent = '';
      errorBox.hidden = true;
    };

    const showError = (message) => {
      if (!errorBox) return;
      errorBox.textContent = message;
      errorBox.hidden = false;
    };

    const validateDate = () => {
      clearError();

      if (!dateInput.value) return true;

      if (dateInput.value < minDate || dateInput.value > maxDate) {
        showError(`お届け希望日は ${minDate} ～ ${maxDate} の範囲でご指定ください。`);
        return false;
      }

      return true;
    };

    dateInput.addEventListener('change', validateDate);
    dateInput.addEventListener('input', validateDate);

    if (form) {
      form.addEventListener('submit', (event) => {
        if (!validateDate()) {
          event.preventDefault();
          dateInput.focus();
        }
      });
    }
  });
})();